import { put, takeLatest, call } from "redux-saga/effects";
import {
  GET_PANELS_STREETLIGHTS_INFO_ACTION,
  panelsStreetlightsInfoLoadingAction,
  panelsStreetlightsInfoSuccessAction,
  panelsStreetlightsInfoFailureAction,
} from "../actions/dashboard.action";
import { getPanelStreetLightInfo } from "../apis/api";

function* triggerGetPanelsStreetlightsInfo(action) {
  try {
    yield put(panelsStreetlightsInfoLoadingAction(true));
    // API call
    const { status, data } = yield call(
      getPanelStreetLightInfo,
      action.payload
    );
    yield put(panelsStreetlightsInfoLoadingAction(false));
    if (status === 200) {
      yield put(panelsStreetlightsInfoSuccessAction(data));
    } else {
      yield put(panelsStreetlightsInfoFailureAction());
    }
  } catch (error) {
    yield put(panelsStreetlightsInfoFailureAction());
  }
}

export default function* watchForDashboardActions() {
  yield takeLatest(
    GET_PANELS_STREETLIGHTS_INFO_ACTION,
    triggerGetPanelsStreetlightsInfo
  );
}
